// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TE8s","left":"styles_left__3vdF7"};